import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

import "../css/style.css";
import logo from "../images/minda-logo.png";
import { getDealers, register, sendOtp } from "../api";
import { COUNTRY_CODES } from "../constants/countryCodes";
import {handleSendOtp} from './handleSendOtp'

function Reg2() {
  const navigate = useNavigate();
  const { serialNumber } = useParams();

  const [dealers, setDealers] = useState([]);
  const [sendingOtp, setSendingOtp] = useState(false);
  const [internationalOtpMethod, setInternationalOtpMethod] = useState("whatsapp");

  // 🇮🇳 Default India
  const [countryCode, setCountryCode] = useState("+91");
  const isIndia = countryCode === "+91";

  const [formData, setFormData] = useState({
    dealer: null,
    fName: "",
    lName: "",
    mobile: "",
    otp: "",
    email: "",
    whatsapp: "",
    pwd: "",
    cPwd: "",
    addr: "",
    city: "",
    state: "",
    pincode: "",
    machinename: "",
    machSerial: serialNumber || "",
    isInternational: !isIndia,
    countryCode:countryCode
  });

  const [formErr, setFormErr] = useState({
    dealer: "Required",
    fName: "Required",
    lName: "Required",
    mobile: "Required", // only enforced for India
    otp: "Required",
    email: "",
    whatsapp: "",
    pwd: "Required",
    cPwd: "Required",
    addr: "Required",
    city: "Required",
    state: "Required",
    machinename: "Required",
    pincode: "Required",
  });

  useEffect(() => {
    getDealers().then((res) => {
      if (res) setDealers(res);
    });
  }, [serialNumber]);

  const updateForm = (key, value, required) => {
    const fd = { ...formData };
    const fe = { ...formErr };

    fd[key] = value;

    if (required && !value) {
      fe[key] = "Required";
    } else {
      fe[key] = "";
    }

    setFormData(fd);
    setFormErr(fe);
  };

  const handleCountryChange = (value) => {
    const fd = { ...formData };
    const fe = { ...formErr };

    setCountryCode(value);

    if (value === "+91") {
      // India → mobile mandatory
      if (!fd.mobile) {
        fe.mobile = "Required";
      }
      fe.email = "";
      fe.whatsapp = "";
    } else {
      // International → mobile not used
      fd.mobile = "";
      fe.mobile = "";
    }

    setFormData(fd);
    setFormErr(fe);
  };

  const handleInternationalOtpMethodChange = (value) => {
    setInternationalOtpMethod(value);
    setFormErr({
      ...formErr,
      email: "",
      whatsapp: "",
    });
  };

  const getInternationalOtpField = () =>
    internationalOtpMethod === "email" ? "email" : "whatsapp";

  const getInternationalOtpLabel = () =>
    internationalOtpMethod === "email" ? "Email" : "WhatsApp";

  const validateInternationalOtpContact = () => {
    const selectedField = getInternationalOtpField();
    const selectedLabel = getInternationalOtpLabel();
    const selectedValue = formData[selectedField]?.trim();
    const fe = {
      ...formErr,
      email: "",
      whatsapp: ""
    };

    if (!selectedValue) {
      fe[selectedField] = `${selectedLabel} required`;
      setFormErr(fe);
      alert(`${selectedLabel} is required for OTP`);
      return null;
    }

    setFormErr(fe);
    return {
      [selectedField]: selectedValue,
      countryCode:countryCode
    };
  };

  const sendOtpCall = async() => {
    // 🇮🇳 India: SMS OTP using mobile
    if (sendingOtp) return;
    if (isIndia) {
      if (!formData.mobile) {
        alert("Mobile is required");
        return;
      }
      if (!/^\d{10}$/.test(formData.mobile)) {
        alert("Mobile number must be a 10-digit number");
        return;
      }

      // For India SMS OTP
      sendOtp(formData.mobile).then((resp) => {
        if (resp && resp.success) {
          alert("OTP sent via SMS");
        } else {
          alert("Failed to send OTP");
        }
      });

      return;
    }

    const contact = validateInternationalOtpContact();
    if (!contact) {
      return;
    }

    try {
        setSendingOtp(true);

        const resp = await handleSendOtp(contact);
        const destination = contact.email || contact.whatsapp || "your contact";

        if (resp && resp.success) {
        alert(`OTP sent to ${destination}`);
        } else {
        alert(resp?.message || "Failed to send OTP");
        }
    } catch (err) {
        console.error(err);
        alert("Error while sending international OTP");
    } finally {
        // ✅ THIS makes sure button stops "Please wait"
        setSendingOtp(false);
    }
  };

  const submit = () => {
    if (!isIndia && !validateInternationalOtpContact()) {
      return;
    }

    // Check all fields that still have an error
    for (let k of Object.keys(formErr)) {
      if (k && formErr[k]) {
        alert(`${k} is invalid`);
        return;
      }
    }

    // Mobile checks only for India
    if (isIndia) {
      if (!/^\d{10}$/.test(formData.mobile)) {
        alert("Mobile number must be a 10-digit number");
        return;
      }
    }

    // Password validations
    if (formData.pwd.length < 8) {
      alert("Password must be atleast 8 character long");
      return;
    }
    if (formData.pwd !== formData.cPwd) {
      alert(`Password confirmation doesn't match`);
      return;
    }
    if (!formData.pwd.match(/[A-Z]/g)) {
      alert(`Password must contain Capital letter`);
      return;
    }
    if (!formData.pwd.match(/[a-z]/g)) {
      alert(`Password must contain small letter`);
      return;
    }
    if (!formData.pwd.match(/[0-9]/g)) {
      alert(`Password must contain number letter`);
      return;
    }

    const payload = {
      ...formData,
      countryCode,
      isInternational: !isIndia,
    };

    register(payload).then((resp) => {
      if (resp && resp.success) {
        if (resp.token) {
          sessionStorage.setItem("token", resp.token);
          navigate("/home", { replace: true });
        } else {
          alert("Registered successfully");
        }
      } else {
        alert("Failed to register");
      }
    });
  };

  const states = [
    "Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chhattisgarh",
    "Delhi",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Maharashtra",
    "Madhya Pradesh",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Odisha",
    "Punjab",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Tripura",
    "Telangana",
    "Uttar Pradesh",
    "Uttarakhand",
    "West Bengal",
    "Andaman & Nicobar",
    "Chandigarh",
    "Dadra & Nagar Haveli",
    "Daman & Diu",
    "Jammu & Kashmir(UT)",
    "Lakshadweep",
    "Ladakh",
    "Puducherry",
  ];

  const fieldClassName = "form-group !flex !flex-col !gap-2";
  const fieldFullClassName = `${fieldClassName} md:!col-span-2`;
  const inputClassName =
    "!min-h-11 !rounded-xl !px-3.5 !py-2 !text-sm !leading-5";
  const buttonClassName =
    "btn btn-secondary !min-h-11 !rounded-xl !px-5 whitespace-nowrap";
  const submitClassName =
    "btn btn-primary btn-block !min-h-11 !rounded-xl !text-base";
  const otpMethodCardClassName =
    "flex items-center gap-3 rounded-xl border border-[var(--InputBorder)] bg-[var(--InputBgColor)] px-3.5 py-2.5 text-left transition-colors";
  const otpMethodCardActiveClassName =
    "border-[var(--PrimaryColor)] bg-[rgba(59,130,246,0.08)]";

  const renderError = (key) => (
    <span className="min-h-4 m-0 text-xs leading-[1.35] text-[var(--ErrorColor)]">
      {formErr[key] || ""}
    </span>
  );

  return (
    <div className="main-page">
      <div className="login-main !m-auto !w-[92vw] !max-w-[760px]">
        <div className="logo">
          <img src={logo} alt="logo" />
        </div>

        <div className="login-wrapper !mt-6 !rounded-3xl !p-4 sm:!p-5 md:!p-7 shadow-[var(--contextMenuShadow)]">
          <div className="login-form w-full">
            <div className="mb-4 flex flex-col gap-1.5 md:mb-5">
              <h1 className="m-0 text-[26px] font-semibold leading-[1.15] text-[var(--PrimaryColor)] md:text-[30px]">
                Create your account
              </h1>
              <p className="m-0 text-sm leading-5 text-[var(--DarkGrayColor)]">
                Complete the registration details below to continue with your
                machine setup.
              </p>
            </div>

            <div className="form !gap-4">
              <div className="grid !grid-cols-1 items-start gap-3 md:!grid-cols-2 md:gap-x-4 md:gap-y-4">
                <div className={fieldClassName}>
                  <label>Machine Serial</label>
                  <input
                    type="text"
                    value={formData.machSerial || ""}
                    disabled
                    className={inputClassName}
                  />
                </div>

                <div className={fieldClassName}>
                  <label>Country *</label>
                  <select
                    value={countryCode}
                    onChange={(e) => handleCountryChange(e.target.value)}
                    className={inputClassName}
                  >
                    {COUNTRY_CODES.map((c) => (
                      <option key={c.code} value={c.code}>
                        {c.flag ? `${c.flag} ` : ""}
                        {c.label} ({c.code})
                      </option>
                    ))}
                  </select>
                </div>

                <div className={fieldFullClassName}>
                  <label>Dealer *</label>
                  <select
                    value={formData.dealer || ""}
                    onChange={(x) => {
                      updateForm("dealer", x.target.value, true);
                    }}
                    tabIndex={0}
                    className={inputClassName}
                  >
                    <option value="">Select Dealer</option>
                    {dealers.map((d) => (
                      <option value={d._id} key={d._id}>
                        {d.name}
                      </option>
                    ))}
                  </select>
                  {renderError("dealer")}
                </div>

                <div
                  className={fieldClassName}
                  onChange={(x) => {
                    updateForm("fName", x.target.value, true);
                  }}
                >
                  <label>First Name *</label>
                  <input
                    type="text"
                    placeholder="First Name *"
                    tabIndex={1}
                    className={inputClassName}
                  />
                  {renderError("fName")}
                </div>

                <div
                  className={fieldClassName}
                  onChange={(x) => {
                    updateForm("lName", x.target.value, true);
                  }}
                >
                  <label>Last Name *</label>
                  <input
                    type="text"
                    placeholder="Last Name *"
                    tabIndex={2}
                    className={inputClassName}
                  />
                  {renderError("lName")}
                </div>

                {isIndia ? (
                  <div
                    className={fieldFullClassName}
                    onChange={(x) => {
                      updateForm("mobile", x.target.value, true);
                    }}
                  >
                    <label>Mobile *</label>
                    <div className="flex flex-col items-stretch gap-3 md:flex-row md:items-center">
                      <input
                        type="text"
                        placeholder="Mobile *"
                        tabIndex={3}
                        className={`${inputClassName} min-w-0 flex-1`}
                      />
                      <button
                        type="button"
                        className={buttonClassName}
                        onClick={sendOtpCall}
                      >
                        Send OTP
                      </button>
                    </div>
                    {renderError("mobile")}
                  </div>
                ) : (
                  <>
                    <div className={fieldFullClassName}>
                      <label>Preferred OTP Method *</label>
                      <div className="grid !grid-cols-1 gap-2 sm:!grid-cols-2">
                        <button
                          type="button"
                          className={`${otpMethodCardClassName} ${
                            internationalOtpMethod === "whatsapp"
                              ? otpMethodCardActiveClassName
                              : ""
                          }`}
                          onClick={() =>
                            handleInternationalOtpMethodChange("whatsapp")
                          }
                        >
                          <span className="flex h-5 w-5 items-center justify-center rounded-full border border-[var(--InputBorder)]">
                            <span
                              className={`h-2.5 w-2.5 rounded-full ${
                                internationalOtpMethod === "whatsapp"
                                  ? "bg-[var(--PrimaryColor)]"
                                  : "bg-transparent"
                              }`}
                            />
                          </span>
                          <span className="flex flex-col">
                            <span className="text-sm font-medium text-[var(--DarkColor)]">
                              WhatsApp
                            </span>
                            <span className="text-xs text-[var(--DarkGrayColor)]">
                              Receive OTP on your WhatsApp number
                            </span>
                          </span>
                        </button>

                        <button
                          type="button"
                          className={`${otpMethodCardClassName} ${
                            internationalOtpMethod === "email"
                              ? otpMethodCardActiveClassName
                              : ""
                          }`}
                          onClick={() =>
                            handleInternationalOtpMethodChange("email")
                          }
                        >
                          <span className="flex h-5 w-5 items-center justify-center rounded-full border border-[var(--InputBorder)]">
                            <span
                              className={`h-2.5 w-2.5 rounded-full ${
                                internationalOtpMethod === "email"
                                  ? "bg-[var(--PrimaryColor)]"
                                  : "bg-transparent"
                              }`}
                            />
                          </span>
                          <span className="flex flex-col">
                            <span className="text-sm font-medium text-[var(--DarkColor)]">
                              Email
                            </span>
                            <span className="text-xs text-[var(--DarkGrayColor)]">
                              Receive OTP in your email inbox
                            </span>
                          </span>
                        </button>
                      </div>
                    </div>

                    <div className={fieldFullClassName}>
                                            <div className="grid !grid-cols-1 gap-2 sm:!grid-cols-2">

                      {internationalOtpMethod === "whatsapp" ? (
                        <div
                          className={fieldClassName}
                          onChange={(x) => {
                            updateForm("whatsapp", x.target.value, false);
                          }}
                        >
                          <label>WhatsApp</label>
                          <input
                            type="text"
                            placeholder="WhatsApp number with country code"
                            tabIndex={3}
                            className={inputClassName}
                          />
                          {renderError("whatsapp")}
                        </div>
                      ) : (
                        <div
                          className={fieldClassName}
                          onChange={(x) => {
                            updateForm("email", x.target.value, false);
                          }}
                        >
                          <label>Email</label>
                          <input
                            type="text"
                            placeholder="Email"
                            tabIndex={4}
                            className={inputClassName}
                          />
                          {renderError("email")}
                        </div>
                      )}

                        <button
                          type="button"
                          className={`${buttonClassName}`}
                          onClick={sendOtpCall}
                          disabled={sendingOtp}
                          style={{
                            padding: "10px 20px",
                            margin: "25px 20px",
                            height: "45px",
                            minWidth: "140px",
                            fontSize: "14px"
                          }}
                        >
                          {sendingOtp ? "Please wait..." : "Send OTP"}
                        </button>
                    </div>
                    </div>

                  </>
                )}

                <div
                  className={fieldClassName}
                  onChange={(x) => {
                    updateForm("otp", x.target.value, true);
                  }}
                >
                  <label>OTP *</label>
                  <input
                    type="text"
                    placeholder="OTP *"
                    tabIndex={5}
                    className={inputClassName}
                  />
                  {renderError("otp")}
                </div>

                <div
                  className={fieldClassName}
                  onChange={(x) => {
                    updateForm("pwd", x.target.value, true);
                  }}
                >
                  <label>Password *</label>
                  <input
                    type="password"
                    placeholder="Password *"
                    tabIndex={6}
                    className={inputClassName}
                  />
                  {renderError("pwd")}
                </div>

                <div
                  className={fieldClassName}
                  onChange={(x) => {
                    updateForm("cPwd", x.target.value, true);
                  }}
                >
                  <label>Confirm Password *</label>
                  <input
                    type="password"
                    placeholder="Confirm Password *"
                    tabIndex={7}
                    className={inputClassName}
                  />
                  {renderError("cPwd")}
                </div>

                <div
                  className={fieldClassName}
                  onChange={(x) => {
                    updateForm("machinename", x.target.value, true);
                  }}
                >
                  <label>Machine Name *</label>
                  <input
                    type="text"
                    placeholder="Machine Name *"
                    tabIndex={10}
                    className={inputClassName}
                  />
                  {renderError("machinename")}
                </div>

                <div
                  className={fieldFullClassName}
                  onChange={(x) => {
                    updateForm("addr", x.target.value, true);
                  }}
                >
                  <label>Address *</label>
                  <input
                    type="text"
                    placeholder="Address *"
                    tabIndex={8}
                    className={inputClassName}
                  />
                  {renderError("addr")}
                </div>

                <div
                  className={fieldClassName}
                  onChange={(x) => {
                    updateForm("city", x.target.value, true);
                  }}
                >
                  <label>City *</label>
                  <input
                    type="text"
                    placeholder="City *"
                    tabIndex={9}
                    className={inputClassName}
                  />
                  {renderError("city")}
                </div>

                <div
                  className={fieldClassName}
                  onChange={(x) => {
                    updateForm("state", x.target.value, true);
                  }}
                >
                  <label>{isIndia ? "State *" : "State / Province *"}</label>

                  {isIndia ? (
                    <select defaultValue="" className={inputClassName}>
                      <option value="" disabled>
                        Select State
                      </option>
                      {states.map((s) => (
                        <option key={s} value={s}>
                          {s}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <input
                      type="text"
                      placeholder="Enter your State / Province"
                      tabIndex={9}
                      className={inputClassName}
                    />
                  )}
                  {renderError("state")}
                </div>

                <div
                  className={fieldFullClassName}
                  onChange={(x) => {
                    updateForm("pincode", x.target.value, true);
                  }}
                >
                  <label>Pincode *</label>
                  <input
                    type="text"
                    placeholder="Pincode *"
                    tabIndex={11}
                    className={inputClassName}
                  />
                  {renderError("pincode")}
                </div>

                <div className={fieldFullClassName}>
                  <button
                    type="submit"
                    className={submitClassName}
                    tabIndex={12}
                    onClick={submit}
                  >
                    Sign Up
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Reg2;
